export default __webpack_public_path__ + "19d621f0b7df4d9bb32d1fb320e22a4a.png";